import { render, staticRenderFns } from "./DoorNumberOfBrokenTiles.vue?vue&type=template&id=2c906850"
import script from "./DoorNumberOfBrokenTiles.vue?vue&type=script&lang=ts"
export * from "./DoorNumberOfBrokenTiles.vue?vue&type=script&lang=ts"
import style0 from "./DoorNumberOfBrokenTiles.vue?vue&type=style&index=0&id=2c906850&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports